import React, { memo } from 'react';
import { Facebook, Twitter, Instagram, Linkedin } from 'lucide-react';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-gray-900 text-white" data-id="element-101">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-102">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8" data-id="element-103">
          <div className="md:col-span-1" data-id="element-104">
            <h2 className="text-2xl font-bold text-indigo-400 mb-4" data-id="element-105">Turnout</h2>
            <p className="text-gray-300 mb-4" data-id="element-106">
              Experience exceptional, affordable events.
            </p>
            <div className="flex space-x-4" data-id="element-107">
              <a href="https://www.facebook.com/profile.php?id=61573120415222" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors" data-id="element-108">
                <Facebook size={20} data-id="element-109" />
              </a>
              <a href="https://x.com/academi_xyz" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors" data-id="element-110">
                <Twitter size={20} data-id="element-111" />
              </a>
              <a href="https://www.instagram.com/academi.xyz/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors" data-id="element-112">
                <Instagram size={20} data-id="element-113" />
              </a>
              <a href="https://www.linkedin.com/company/academi-xyz/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors" data-id="element-114">
                <Linkedin size={20} data-id="element-115" />
              </a>
            </div>
          </div>
          <div data-id="element-116">
            <h3 className="text-lg font-semibold mb-4" data-id="element-117">Services</h3>
            <ul className="space-y-2" data-id="element-118">
              <li data-id="element-119">
                <a href="#services" className="text-gray-400 hover:text-white transition-colors" data-id="element-120">
                  Corporate Events
                </a>
              </li>
              <li data-id="element-121">
                <a href="#services" className="text-gray-400 hover:text-white transition-colors" data-id="element-122">
                  Social Gatherings
                </a>
              </li>
              <li data-id="element-123">
                <a href="#services" className="text-gray-400 hover:text-white transition-colors" data-id="element-124">
                  Entertainment
                </a>
              </li>
              <li data-id="element-125">
                <a href="#services" className="text-gray-400 hover:text-white transition-colors" data-id="element-126">
                  Event Planning
                </a>
              </li>
              <li data-id="element-127">
                <a href="#services" className="text-gray-400 hover:text-white transition-colors" data-id="element-128">
                  Photography & Video
                </a>
              </li>
              <li data-id="element-129">
                <a href="#services" className="text-gray-400 hover:text-white transition-colors" data-id="element-130">
                  Award Ceremonies
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-131">
            <h3 className="text-lg font-semibold mb-4" data-id="element-132">Company</h3>
            <ul className="space-y-2" data-id="element-133">
              <li data-id="element-134">
                <a href="#about" className="text-gray-400 hover:text-white transition-colors" data-id="element-135">
                  About Us
                </a>
              </li>
              <li data-id="element-136">
                <a href="#portfolio" className="text-gray-400 hover:text-white transition-colors" data-id="element-137">
                  Portfolio
                </a>
              </li>
              <li data-id="element-138">
                <a href="#testimonials" className="text-gray-400 hover:text-white transition-colors" data-id="element-139">
                  Testimonials
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-140">
            <h3 className="text-lg font-semibold mb-4" data-id="element-141">Legal</h3>
            <ul className="space-y-2" data-id="element-142">
              <li data-id="element-143">
                <a href="https://docs.google.com/document/d/1HAZaZGu4ejcYphouQQGkXGUJd2il_LeQ6eTjj86GCQE/edit?usp=drive_web&ouid=107501030604000419011" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors" data-id="element-144">
                  Privacy Policy
                </a>
              </li>
              <li data-id="element-145">
                <a href="https://docs.google.com/document/d/1SB9umObVrSOeRQ980QkfM6CooUfdz4gMGKM_DGYPego/edit?tab=t.0" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors" data-id="element-146">
                  Terms of Service
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-12 pt-8 border-t border-gray-800 text-center text-gray-400" data-id="element-147">
          <p data-id="element-148">&copy; {currentYear} Turnout Events. All rights reserved.</p>
          <p className="mt-2 text-sm" data-id="element-149">Academi Technologies Inc.</p>
        </div>
      </div>
    </footer>;
}